export default {
    getAdditionalServices: { method: 'get', url: 'emcadmin/additional-services' },
    postAdditionalServices: { method: 'post', url: 'emcadmin/additional-services' },
    putAdditionalServices: { method: 'put', url: 'emcadmin/additional-services/{id}' },
    deleteAdditionalServices: { method: 'delete', url: 'emcadmin/additional-services/{id}' },
}
